import PropTypes from "prop-types"
import { UUID, DATE } from "helpers/shapes"

export const TEAM = PropTypes.shape({
  id: UUID.isRequired,
  name: PropTypes.string.isRequired,
  createdAt: DATE.isRequired,
})
